import React, {ReactNode} from 'react';
import {FeatureFlags, defaultFlags} from '@common/types/FeatureFlags';
import coerceBool from '../helpers/coerceBool';

const FeatureFlagsContext = React.createContext(defaultFlags);

const parseFeatureFlags = (
  obj: FeatureFlags,
  defaults: FeatureFlags
): FeatureFlags => {
  const parsedFlags: FeatureFlags = {...defaults};
  Object.keys(obj || {}).forEach(
    key =>
      (parsedFlags[key as keyof FeatureFlags] = coerceBool(
        obj[key as keyof FeatureFlags]
      ))
  );
  return parsedFlags;
};

type FeatureFlagsProviderProps = {
  children: ReactNode;
  featureFlags: FeatureFlags;
};
const FeatureFlagsProvider = ({
  children,
  featureFlags
}: FeatureFlagsProviderProps) => (
  <FeatureFlagsContext.Provider
    value={{...parseFeatureFlags(featureFlags, defaultFlags)}}
  >
    {children}
  </FeatureFlagsContext.Provider>
);

export {FeatureFlagsProvider as default, FeatureFlagsContext};
